import React, { useState } from "react";
import { Breadcrumb, Button, Col, Dropdown, Row } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { FaFileExport } from "react-icons/fa";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import BudgetCard from "../../components/Dashboard/finance-dashboard/BudgetCard";
import PayrollCard from "../../components/Dashboard/finance-dashboard/PayrollCard";
import ReimbursementCard from "../../components/Dashboard/finance-dashboard/ReimbursementCard";
import HeadcountCard from "../../components/Dashboard/finance-dashboard/HeadcountCard";
import HRCostCard from "../../components/Dashboard/finance-dashboard/HRCostCard";
import HelpCard from "../../components/Dashboard/finance-dashboard/HelpCard";
import BudgetChart from "../../components/Dashboard/finance-dashboard/BudgetChart";
import FinancialHealth from "../../components/Dashboard/finance-dashboard/FinancialHealth";
import PayrollForecast from "../../components/Dashboard/finance-dashboard/PayrollForecast";
import PendingPayments from "../../components/Dashboard/finance-dashboard/PendingPayments";
import RecentHRTransactions from "../../components/Dashboard/finance-dashboard/RecentHRTransactions";


const FinancialDashboardPage = () => {
  const today = new Date();

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US");
  };

  const getRange = (type) => {
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "Today":
        break;

      case "Yesterday":
        start.setDate(today.getDate() - 1);
        end.setDate(today.getDate() - 1);
        break;

      case "Last 7 Days":
        start.setDate(today.getDate() - 6);
        break;

      case "Last 30 Days":
        start.setDate(today.getDate() - 29);
        break;

      case "This Year":
        start = new Date(today.getFullYear(), 0, 1);
        break;

      case "Next Year":
        start = new Date(today.getFullYear() + 1, 0, 1);
        end = new Date(today.getFullYear() + 1, 11, 31);
        break;

      default:
        break;
    }

    return `${formatDate(start)} - ${formatDate(end)}`;
  };

  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
  ];

  const [selected, setSelected] = useState("Last 7 Days");
  const [range, setRange] = useState(getRange("Last 7 Days"));

  const handleSelect = (item) => {
    setSelected(item);
    setRange(getRange(item));
  };

  return (
    <div className="finance-wrapper">

      {/* HEADER */}
      <div className="finance-header">

       <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Finance Dashboard</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                       gap:"0px",
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        />
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Dashboard
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Finance Dashboard</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT */}
        <div className="actions">

          {/* DATE DROPDOWN */}
          <Dropdown>
            <Dropdown.Toggle className="date-btn">
              <FiCalendar className="mb-1" />
              {range}
            </Dropdown.Toggle>

            <Dropdown.Menu className="date-menu">
              {options.map((item, i) => (
                <Dropdown.Item
                  key={i}
                  active={selected === item}
                  onClick={() => handleSelect(item)}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* EXPORT */}
          <Button className="export-btn">
            <FaFileExport /> Export CSV
          </Button>

          {/* <Button className="collapse-btn">⌃</Button> */}
        </div>
      </div>

      {/* LATE ARRIVALS */}
      {/* <div className="mt-3">
        <LateArrivals />
      </div> */}
        <div className="row g-3">

        <div className="col-xl-6">
          <BudgetCard />
        </div>

        <div className="col-xl-3 col-md-6">
          <PayrollCard />
        </div>

        <div className="col-xl-3 col-md-6">
          <ReimbursementCard />
        </div>

      </div>
            <Row  className="mt-3" >
        <Col xl={8}>
          <HeadcountCard />
        </Col>

        <Col xl={4} className="mobile-gap">
          <HRCostCard />
        </Col>
            </Row>

            <Row className="mt-3">
        <Col xl={5} xxl={4} className="d-flex mb-3">
          <HelpCard />
        </Col>

        <Col xl={7} xxl={8} className="d-flex mb-3">
          <BudgetChart />
        </Col>
      </Row>
        

         <Row className=" mt-2">
      <Col xxl={6} lg={12}>
        <FinancialHealth />
      </Col>

      <Col xxl={3} md={6} xs={12}>
        <PayrollForecast />
      </Col>

      <Col xxl={3} md={6} xs={12}>
        <PendingPayments />
      </Col>
    </Row>
    <Row className="mt-2">
      <RecentHRTransactions/>
    </Row>

      {/* CSS */}
      <style>{`
        .finance-wrapper {
          padding: 20px;
          background: #f8f9fb;
        }
 @media (max-width: 1024px) {
          .row > div {
            margin-top: 10px;
          }
        }
        .finance-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
        }

        h2 {
          font-size: 26px;
          font-weight: 700;
          margin-bottom: 5px;
          color: #1e293b;
        }

        .breadcrumb {
          font-size: 14px;
          color: #64748b;
          display: flex;
          gap: 6px;
        }

        .breadcrumb .active {
          color: #1e293b;
          font-weight: 500;
        }

        .actions {
          display: flex;
          align-items: center;
          gap: 10px;
        }

     
/* 🔥 FIX DROPDOWN TOGGLE (no white on hover/click) */
.date-btn,
.date-btn:focus,
.date-btn:active,
.show > .date-btn.dropdown-toggle {
  background-color: #fff !important;
  color: #333 !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: none !important;
}

/* 🔥 FIX DROPDOWN MENU BACKGROUND */
.dropdown-menu {
  background-color: #fff !important;
  border-radius: 10px;
  border: 1px solid #eee;
  overflow: hidden;
}

/* 🔥 HOVER ITEM (ORANGE) */
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #ff7a2f !important;
  color: #fff !important;
}

/* 🔥 REMOVE WHITE FLASH */
.dropdown-item {
  background-color: transparent !important;
}



        .dropdown-item.active {
          background: #f97316 !important;
          color: #fff !important;
        }

        .export-btn {
          background: #f97316;
          border: none;
          color: #fff;
          padding: 8px 14px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

.dropdown-toggle::after {
  display: none !important;
}
        .collapse-btn {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 8px 12px;
        }

        @media (max-width: 768px) {
          .finance-header {
            flex-direction: column;
            align-items: flex-start;
          }

          .actions {
            width: 100%;
            flex-direction: column;
          }

          .date-toggle,
          .export-btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
};

export default FinancialDashboardPage;